import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { SimulatorModel } from '../models/SimulatorModel';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { OfferProductionModel } from '../models/OfferProductionModel';
import { PolicyType } from '../models/superbit-api-models';
import { GeneralDataModel } from '../models/GeneralDataModel';


type Props = {
    filter: any;
    policyTypes: any[];
    productionTypes: any[];
    onApprove: Function;
    onClear: Function;
    onHide: Function;
};

const AdvancedSigningSearch = (props: Props) => {
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const offerProductionModel: OfferProductionModel = new OfferProductionModel();
    const [filter, setFilter] = useState<any>(props.filter ? props.filter : {});
    const [productionType, setProductionType] = useState<string>('-1');
    const [leadSource, setLeadSource] = useState<string>('-1');
    const [creatorsList, setCreatorsList] = useState<any[]>([]);
    const [handlersList, setHandlersList] = useState<any[]>([]);
    const [createdBy, setCreatedBy] = useState<string>('');
    const [handledBy, setHandledBy] = useState<string>('');

    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
    const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState<string>('');

    const [routesList, setRoutesList] = useState<any[]>([]);
    const [selectedRouteId, setSelectedRouteId] = useState<string | null>(null);

    const [startDateFrom, setStartDateFrom] = useState<Date | null>(null);
    const [startDateTo, setStartDateTo] = useState<Date | null>(null);
    const [createdDateFrom, setCreatedDateFrom] = useState<Date | null>(null);
    const [createdDateTo, setCreatedDateTo] = useState<Date | null>(null);

    const [agents, setAgents] = useState<any[]>([])
    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [selectedAgent, setSelectedAgent] = useState<string>('0');


    const [insuranceTypes, setInsuranceTypes] = useState<any[]>([]);
    const [insuranceType, setInsuranceType] = useState<string>('-1');

    const [policyType, setPolicyType] = useState<string>('-1');

    const [policyStatuses, setPolicyStatuses] = useState<any[]>([]);
    const [selectedPolicyStatus, setSelectedPolicyStatus] = useState<string>(props.filter.openPolicies ? '1' : '0');
    const [handlersAllList, setHandlersAllList] = useState<any[]>([]);

    const [collectionStep, setCollectionStep] = useState<string>('');
    const [protectionStep, setProtectionStep] = useState<string>('');
    const [lackOfClaimsStep, setLackOfClaimsStep] = useState<string>('');
    const [documentsStep, setDocumentsStep] = useState<string>('');
    const [sendingToCustomerStep, setSendingToCustomerStep] = useState<string>('');






    const init = async () => {

        rebuildCreatorsList(-1);

        const signingUsersData = await offerProductionModel.getUserByRoleId();
        setHandlersAllList(signingUsersData.map((su: any) => {
            return {
                label: su.fullName,
                value: su.id,
                active: su.status === 0
            }
        }));
        // rebuildHandlersList(-1);

        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [{
            value: '-1',
            label: 'פלוס שירותי דרך'
        }];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name
            })
        });
        fixedInsuranceCompanies.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1)
        setInsuranceCompanyList(fixedInsuranceCompanies);

        const InsuranceTypesData = await generalModel.getAppDictionaryListExpanded();
        const insuranceTypesKeys = Object.keys(InsuranceTypesData);
        const insuranceTypesList: any[] = [];
        insuranceTypesKeys.forEach((key: string) => {
            const item = InsuranceTypesData[key];
            insuranceTypesList.push(
                {
                    label: item.description,
                    value: item.id.toString()
                })

        });
        console.log('insuranceTypesList', insuranceTypesList)
        setInsuranceTypes(insuranceTypesList);
        console.log(insuranceTypesList);


        const agentsData = await simulatorModel.getCustomerCardAgents();
        await setAgents(agentsData);
        await setAgentsList(agentsData.map((a: any) => {
            return {
                value: a.id,
                label: a.name
            }
        }));

        const policyStatusesData = await offerProductionModel.getPolicyStatuses();
        setPolicyStatuses(policyStatusesData.map((ps: any) => {
            return {
                label: ps.name,
                value: ps.id.toString()
            }
        }))


        // let loggedUserData: any = localStorage.getItem('loggedUser');
        // if (loggedUserData) {
        //     let loggedUser = JSON.parse(loggedUserData);
        //     if (loggedUser && (loggedUser.role != 0)) {
        //         const newFilter = filter;
        //         newFilter.openPolicies = true;
        //         setSelectedPolicyStatus('-1');
        //         newFilter.ElementaryPolicyStatusId = undefined;
        //         setFilter(newFilter);
        //         onApprove();
        //     }
        // }
    }

    const rebuildCreatorsList = (status: number) => {
        const creatorsList = localStorage.getItem('creatorsList');
        if (creatorsList) {
            const dataList = buildOptionsForSelect(JSON.parse(creatorsList), 'id', status);
            const newCreatorsList: any = [
                {
                    label: 'נוצר ע"י',
                    value: '-1'
                },
                {
                    label: 'יוזרים פעילים',
                    value: '0'
                },
                {
                    label: 'יוזרים לא פעילים',
                    value: '1'
                },
                {
                    label: 'כל היוזרים',
                    value: '2'
                },
                ...dataList
            ]
            setCreatorsList(newCreatorsList)
        }
    }

    const rebuildHandlersList = (status: number) => {
        // const creatorsList = localStorage.getItem('creatorsList');
        if (handlersAllList) {
            let dataList = handlersAllList;
            switch (status) {
                case 0:
                    dataList = handlersAllList.filter((i: any) => i.active === true)
                    break;
                case 1:
                    dataList = handlersAllList.filter((i: any) => i.active === false)
                    break;
                default:
                    break;
            }
            console.log('rebuildHandlersList', status, dataList);
            const newCreatorsList: any = [
                {
                    label: 'נוצר ע"י',
                    value: '-1'
                },
                {
                    label: 'יוזרים פעילים',
                    value: '0'
                },
                {
                    label: 'יוזרים לא פעילים',
                    value: '1'
                },
                {
                    label: 'כל היוזרים',
                    value: '2'
                },
                ...dataList
            ]
            setHandlersList(newCreatorsList)
        }

    }

    const buildOptionsForSelect = (source: any[], param: string = 'id', show: number = -1) => {
        const items: any[] = [];
        source.forEach((i: any) => {
            let include: boolean = false;
            switch (show) {
                case 0:
                    if (i.status === 0) {
                        include = true;
                    }
                    break;
                case 1:
                    if (i.status === 1) {
                        include = true;
                    }
                    break;

                default:
                    include = true;
                    break;
            }
            if (include) {
                items.push(
                    {
                        label: i.fullName,
                        value: i[param],
                        active: i.status === 0
                    }
                );
            }
        })
        console.log('buildOptionsForSelect', items);
        return items;
    }

    const onCreatorChange = async (e: any) => {
        const creatorName = e.target.value;
        const newFilter: any = filter;
        newFilter.creatorUserId = undefined;
        const selected = creatorsList.find((a: any) => a.label == creatorName);
        setCreatedBy(creatorName);
        if (selected) {
            switch (selected.value) {
                case '-1':
                    newFilter.createdBy = undefined;
                    break;
                case '0':
                    setCreatedBy('');
                    // newFilter.createdBy = parseInt(selected.value);
                    rebuildCreatorsList(0);
                    break;
                case '1':
                    setCreatedBy('');
                    // newFilter.createdBy = parseInt(selected.value);
                    rebuildCreatorsList(1);
                    break;
                case '2':
                    setCreatedBy('');
                    // newFilter.createdBy = parseInt(selected.value);
                    rebuildCreatorsList(-1);
                    break;
                default:
                    newFilter.createdBy = '3';
                    newFilter.creatorUserId = selected.value;
                    break;
            }
            setFilter(newFilter);
        } else {
            newFilter.createdBy = undefined
            setFilter(newFilter);
        }
    }

    const clearCreatedBy = () => {
        const newFilter: any = filter;
        newFilter.createdBy = undefined;
        newFilter.creatorUserId = undefined;
        setCreatedBy('');
        setFilter(newFilter);
    }

    const onHandlerChange = async (e: any) => {
        const handlerName = e.target.value;
        const newFilter: any = filter;
        newFilter.underwriterUserId = undefined;
        const selected = handlersList.find((a: any) => a.label == handlerName);
        setHandledBy(handlerName)
        if (selected) {
            switch (selected.value) {
                case '-1':
                    newFilter.underwriterType = undefined;
                    rebuildHandlersList(-1);
                    break;
                case '0':
                    newFilter.underwriterType = parseInt(selected.value);
                    rebuildHandlersList(0);
                    setHandledBy('');
                    break;
                case '1':
                    newFilter.underwriterType = parseInt(selected.value);
                    rebuildHandlersList(1);
                    setHandledBy('');
                    break;
                case '2':
                    newFilter.underwriterType = parseInt(selected.value);
                    rebuildHandlersList(-1);
                    setHandledBy('');
                    break;
                default:
                    newFilter.underwriterType = '3';
                    newFilter.underwriterUserId = selected.value;
                    rebuildHandlersList(-1);
                    break;
            }
            setFilter(newFilter);
        } else {
            rebuildHandlersList(-1);
            newFilter.createdBy = undefined
            setFilter(newFilter);
        }
    }

    const clearHandledBy = () => {
        const newFilter: any = filter;
        newFilter.underwriterType = undefined;
        newFilter.underwriterUserId = undefined;
        setHandledBy('')
        setFilter(newFilter);
    }

    const onInsuranceCompanyChange = async (e: any) => {
        const companyName = e.target.value;
        setSelectedInsuranceCompany(companyName);
        setSelectedRouteId(null);
        const selected = insuranceCompanyList.find((a: any) => a.label == companyName);
        const newFilter = filter;
        if (selected) {
            newFilter.insuranceCompanyId = selected.value
            setSelectedInsuranceCompany(selected.label)
            setFilter(newFilter);
            getRoutesList(selected.value);
        } else {
            newFilter.insuranceCompanyId = undefined
            setFilter(newFilter);
            setRoutesList([])
        }
    }

    const getRoutesList = async (companyId: string) => {
        if (companyId == '-1') {
            setRoutesList([]);
            return;
        }
        setSelectedRouteId(null);
        let data: any = await simulatorModel.getRoutesByInsuranceCompany(companyId);
        if (data) {
            data = data.filter((r: any) => r.comment && r.comment !== '')
            setRoutesList(data.map((r: any) => {
                return {
                    value: r.id,
                    label: r.comment
                }
            }))
        } else {
            setRoutesList([])
        }
    }
    const onRouteChange = async (e: any) => {
        const routeId = e.target.value;
        setSelectedRouteId(routeId);
        const selected = routesList.find((a: any) => a.label == routeId);
        const newFilter = filter;
        if (selected) {
            newFilter.insuranceCompanyRouteId = selected.value;
            newFilter.insuranceCompanyRouteLabel = selected.label;
            setSelectedRouteId(selected.label)
            setFilter(newFilter);
        } else {
            newFilter.insuranceCompanyId = undefined
            setFilter(newFilter);
        }
    }

    const onClearInsuranceCompany = () => {
        const newFilter: any = filter;
        newFilter.insuranceCompanyId = undefined;
        setSelectedInsuranceCompany('');
        setSelectedRouteId(null);
        setRoutesList([]);
        setFilter(newFilter);
    }

    const onProductionTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onProductionTypeChange');
        setProductionType('-1');
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.productionType = parseInt(value);
            setProductionType(value.toString());
        } else {
            newFilter.productionType = undefined;
        }
        setFilter(newFilter);
    }


    const onLeadSourceChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onProductionTypeChange');
        setLeadSource('-1');
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.leadSource = parseInt(value);
            setLeadSource(value.toString());
        } else {
            newFilter.leadSource = undefined;
        }
        setFilter(newFilter);
    }


    const onInsuranceTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onInsuranceTypeChange');
        setInsuranceType('-1');
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.insuranceType = parseInt(value);
            setInsuranceType(value.toString());
        } else {
            newFilter.insuranceType = undefined;
        }
        setFilter(newFilter);
    }

    const onPolicyTypeChange = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('onPolicyTypeChange');
        setPolicyType('-1');
        const newFilter = filter;
        if (value !== '-1') {
            newFilter.policyType = parseInt(value);
            setPolicyType(value.toString());
        } else {
            newFilter.policyType = undefined;
        }
        setFilter(newFilter);
    }


    const onAgentChange = (value: string, option: { label: string; value: string; }) => {
        setSelectedAgent(value);
        const newFilter = filter;
        if (value !== '0') {
            newFilter.agentId = value
        } else {
            newFilter.agentId = undefined;
        }
        setFilter(newFilter);
    }

    const onCreatedFilterDateFromChange = (d: Date) => {
        setCreatedDateFrom(d)
        const newFilter = filter;
        if (d !== null) {
            newFilter.createdDateFrom = d;
        } else {
            newFilter.createdDateFrom = undefined;
        }
        setFilter(newFilter)
    }
    const onCreatedFilterDateToChange = (d: Date) => {
        setCreatedDateTo(d)
        const newFilter = filter;
        if (d !== null) {
            newFilter.createdDateTo = d;
        } else {
            newFilter.createdDateTo = undefined;
        }
        setFilter(newFilter)
    }

    const onStartFilterDateFromChange = (d: Date) => {

        if (d) {
            // strip timezone by constructing a new Date at local midnight
            const localDateOnly = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            setStartDateFrom(localDateOnly);

            const newFilter = { ...filter, startDateFrom: localDateOnly };
            setFilter(newFilter);
        } else {
            setStartDateFrom(null);
            setFilter({ ...filter, startDateFrom: undefined });
        }
    }
    const onStartFilterDateToChange = (d: Date) => {

        setStartDateTo(d)
        const newFilter = filter;
        if (d !== null) {
            newFilter.startDateTo = d;
        } else {
            newFilter.startDateTo = undefined;
        }
        setFilter(newFilter)
    }

    const handleCheckChange = async (name: string, event: any) => {
        const newFilter = filter;
        await setFilter({})
        if (event.target.checked) {
            newFilter[name] = true;
        } else {
            newFilter[name] = undefined;
        }
        await setFilter(newFilter);
    }

    const handleSelectChange = async (key: string, value: string) => {
        setFilter((prev: any) => {
            let newValue: boolean | undefined;

            if (value === "") {
                newValue = undefined;
            } else if (value === "true") {
                newValue = true;
            } else if (value === "false") {
                newValue = false;
            } else {
                // fallback: keep old value if unexpected
                return prev;
            }

            return {
                ...prev,
                [key]: newValue,
            };
        });
    }



    const onPolicyStatusChange = (value: string, option: { label: string; value: string; }) => {
        setSelectedPolicyStatus(value);
        const newFilter = filter;

        if (value !== '0' && value !== '1') {

            newFilter.ElementaryPolicyStatusId = value
            newFilter.openPolicies = false;
        } else if (value == '1') {
            newFilter.openPolicies = true;
            newFilter.ElementaryPolicyStatusId = null;
        }
        else {
            newFilter.openPolicies = false;

        }
        setFilter(newFilter);
    }

    const onApprove = () => {
        if (props.onApprove) {
            const newFilter = filter;
            props.onApprove(newFilter);
        }
    }
    const onClear = () => {
        setFilter({});
        setSelectedRouteId('');
        if (props.onClear) {
            props.onClear()
        }
    }

    const onClose = () => {
        if (props.onHide) {
            props.onHide()
        }
    }

    useEffect(() => {
        // buildOptionslist();
        init();
    }, []);

    useEffect(() => {
        console.log('useEffect-props', props)
        if (props.filter) {
            setFilter(props.filter)
            if (typeof props.filter.creatorUserId !== 'undefined') {
                const selected = creatorsList.find((a: any) => a.value == props.filter.creatorUserId);
                if (selected) {
                    setCreatedBy(selected.label)
                } else {
                    setCreatedBy('');
                }
            } else {
                setCreatedBy('');
            }

            if (typeof props.filter.productionType !== 'undefined') {
                setProductionType(props.filter.productionType.toString());
            } else {
                setProductionType('-1');
            }
            if (typeof props.filter.insuranceType !== 'undefined') {
                setInsuranceType(props.filter.insuranceType.toString());
            } else {
                setInsuranceType('-1');
            }

            if (typeof props.filter.policyType !== 'undefined') {
                setPolicyType(props.filter.policyType.toString());
            } else {
                setPolicyType('-1');
            }

            if (typeof props.filter.leadSource !== 'undefined') {
                setLeadSource(props.filter.leadSource.toString());
            } else {
                setLeadSource('-1');
            }
            if (typeof props.filter.insuranceCompanyId !== 'undefined') {
                if (props.filter.insuranceCompanyId === '-1') {
                    setSelectedInsuranceCompany('פלוס שירותי דרך');
                }
                const selected = insuranceCompanyList.find((a: any) => a.value == props.filter.insuranceCompanyId);
                if (selected) {
                    setSelectedInsuranceCompany(selected.label)
                } else {
                    setSelectedInsuranceCompany('');
                }
            } else {
                setSelectedInsuranceCompany('');
            }
            if (props.filter.underwriterUserId) {

            } else {
                setHandledBy('')
            }
            if (typeof props.filter.insuranceCompanyRouteId !== 'undefined') {
                const selected = routesList.find((a: any) => a.value == props.filter.insuranceCompanyRouteId);
                if (selected) {
                    setSelectedRouteId(selected.label);
                } else {
                    setSelectedRouteId('');
                }
            } else {
                setSelectedRouteId('');
            }

            if (filter.startDateFrom) {
                setStartDateFrom(filter.startDateFrom);
            } else {
                setStartDateFrom(null);
            }
            if (filter.startDateTo) {
                setStartDateTo(filter.startDateTo);
            } else {
                setStartDateTo(null);
            }

            if (filter.createdDateFrom) {
                setCreatedDateFrom(filter.createdDateFrom);
            } else {
                setCreatedDateFrom(null);
            }

            if (filter.createdDateTo) {
                setCreatedDateTo(filter.createdDateTo);
            } else {
                setCreatedDateTo(null);
            }

            if (filter.ElementaryPolicyStatusId) {
                setSelectedPolicyStatus(filter.ElementaryPolicyStatusId);
            } else {
                // let loggedUserData: any = localStorage.getItem('loggedUser');
                // if (loggedUserData) {
                //     let loggedUser = JSON.parse(loggedUserData);
                //     if (loggedUser && (loggedUser.role != 0)) {
                //         const newFilter = filter;
                //         newFilter.openPolicies = true;
                //         setSelectedPolicyStatus('-1');
                //         newFilter.ElementaryPolicyStatusId = undefined;
                //         setFilter(newFilter);
                //     } else {
                //         setSelectedPolicyStatus('0');

                //     }
                // }
                setSelectedPolicyStatus('0');
            }

            if (filter.agentId) {
                setSelectedAgent(filter.agentId);
            } else {
                setSelectedAgent('0');
            }

            if (filter.insuranceType) {
                setInsuranceType(filter.insuranceType.toString());
            } else {
                setInsuranceType('-1');
            }

            if(props.filter.collectionStep !== '' && ( props.filter.collectionStep === true ||  props.filter.collectionStep === false )){
                console.log('props.filter.collectionStep', props.filter.collectionStep)
                setCollectionStep(props.filter.collectionStep.toString());
            } else{
                console.log('else props.filter.collectionStep', props.filter.collectionStep)
                setCollectionStep('');
            }

            if(props.filter.protectionStep !== '' && ( props.filter.protectionStep === true ||  props.filter.protectionStep === false )){
                console.log('props.filter.protectionStep', props.filter.protectionStep)
                setProtectionStep(props.filter.protectionStep.toString());
            } else{
                console.log('else props.filter.protectionStep', props.filter.protectionStep)
                setProtectionStep('');
            }

            if(props.filter.lackOfClaimsStep !== '' && ( props.filter.lackOfClaimsStep === true ||  props.filter.lackOfClaimsStep === false )){
                console.log('props.filter.lackOfClaimsStep', props.filter.lackOfClaimsStep)
                setLackOfClaimsStep(props.filter.lackOfClaimsStep.toString());
            } else{
                console.log('else props.filter.lackOfClaimsStep', props.filter.lackOfClaimsStep)
                setLackOfClaimsStep('');
            }

            if(props.filter.documentsStep !== '' && ( props.filter.documentsStep === true ||  props.filter.documentsStep === false )){
                console.log('props.filter.documentsStep', props.filter.documentsStep)
                setDocumentsStep(props.filter.documentsStep.toString());
            } else{
                console.log('else props.filter.documentsStep', props.filter.documentsStep)
                setDocumentsStep('');
            }

            if(props.filter.sendingToCustomerStep !== '' && ( props.filter.sendingToCustomerStep === true ||  props.filter.sendingToCustomerStep === false )){
                console.log('props.filter.sendingToCustomerStep', props.filter.sendingToCustomerStep)
                setSendingToCustomerStep(props.filter.sendingToCustomerStep.toString());
            } else{
                console.log('else props.filter.sendingToCustomerStep', props.filter.sendingToCustomerStep)
                setSendingToCustomerStep('');
            }


        } else {
            console.log('useEffect-props - no props.filter')
        }
    }, [props])

    useEffect(() => {
        console.log('filter changed', filter)
    }, filter)

    useEffect(() => {
        rebuildHandlersList(-1);
    }, [handlersAllList])

    return (
        <div className='signing-advanced-search rtl'>
            <div className="close-icon pointer" onClick={onClose}></div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            נוצר ע"י
                        </div>
                        <div className="value">
                            <input type='text'
                                list="cretors_list"
                                placeholder='בחר נוצר ע"י'
                                onChange={(e: any) => onCreatorChange(e)}
                                value={createdBy}
                            />
                            <datalist id="cretors_list">
                                {creatorsList && creatorsList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${createdBy == '' ? 'hide' : ''}`} onClick={clearCreatedBy}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג הפקה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג הפקה"
                                value={productionType}
                                options={[
                                    {
                                        label: 'בחר סוג הפקה',
                                        value: '-1'
                                    },
                                    {
                                        label: 'ידנית',
                                        value: '0'
                                    },
                                    {
                                        label: 'אוטומטית',
                                        value: '1'
                                    }
                                ]}
                                onChange={onProductionTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג אירוע
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג אירוע"
                                value={leadSource}
                                options={[
                                    {
                                        label: 'בחר סוג אירוע',
                                        value: '-1'
                                    },
                                    {
                                        label: 'חדש',
                                        value: '0'
                                    },
                                    {
                                        label: 'חידוש',
                                        value: '1'
                                    }
                                ]}
                                onChange={onLeadSourceChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סטטוס
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                value={selectedPolicyStatus}
                                onChange={(value: string, option: any) => onPolicyStatusChange(value, option)}
                                options={
                                    [
                                        {
                                            label: 'בחר סטטוס',
                                            value: '0'
                                        },
                                        {
                                            label: 'כל הפתוחים',
                                            value: '1'

                                        },

                                        ...policyStatuses
                                    ]
                                }
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            מטפל
                        </div>
                        <div className="value">
                            <input type='text'
                                list="handler_list"
                                placeholder='בחר מטפל'
                                onChange={(e: any) => onHandlerChange(e)}
                                value={handledBy}
                            />
                            <datalist id="handler_list">
                                {handlersList && handlersList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${handledBy == '' ? 'hide' : ''}`} onClick={clearHandledBy}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            חברת ביטוח
                        </div>
                        <div className="value">
                            <input type='text'
                                list="companies_list"
                                placeholder='בחר חברת ביטוח'
                                onChange={(e: any) => onInsuranceCompanyChange(e)}
                                value={selectedInsuranceCompany}
                            />
                            <datalist id="companies_list">
                                {insuranceCompanyList && insuranceCompanyList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                            <div className={`icon x-clear pointer ${selectedInsuranceCompany == '' ? 'hide' : ''}`} onClick={onClearInsuranceCompany}></div>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            מסלול
                        </div>
                        <div className="value">
                            <input type='text'
                                list="routes_list"
                                placeholder='בחר מסלול'
                                onChange={(e: any) => onRouteChange(e)}
                                value={selectedRouteId ? selectedRouteId : ''}
                            />
                            <datalist id="routes_list">
                                {routesList && routesList.map((c: any, i) => <option key={i} value={c.label}>{c.label}</option>)}
                            </datalist>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוכן
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                value={selectedAgent}
                                onChange={(value: string, option: any) => onAgentChange(value, option)}
                                options={
                                    [
                                        {
                                            label: 'בחר סוכן ביטוח',
                                            value: '0'
                                        },
                                        ...agentsList
                                    ]
                                }
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            ת. יצירה מ
                        </div>
                        <div className="value">
                            <CompDatePicker value={createdDateFrom} onChange={(date: Date) => onCreatedFilterDateFromChange(date)} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            ת. יצירה עד
                        </div>
                        <div className="value">
                            <CompDatePicker value={createdDateTo} onChange={(date: Date) => onCreatedFilterDateToChange(date)} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            יעד סיום מ
                        </div>
                        <div className="value">
                            <CompDatePicker value={startDateFrom} onChange={(date: Date) => onStartFilterDateFromChange(date)} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            יעד סיום עד
                        </div>
                        <div className="value">
                            <CompDatePicker value={startDateTo} onChange={(date: Date) => onStartFilterDateToChange(date)} />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row">
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג ביטוח
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג ביטוח"
                                value={insuranceType}
                                options={[
                                    {
                                        label: 'בחר סוג ביטוח',
                                        value: '-1'
                                    },
                                    ...insuranceTypes
                                ]}
                                onChange={onInsuranceTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            סוג הפוליסה
                        </div>
                        <div className="value">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר סוג פוליסה"
                                value={policyType}
                                options={[
                                    {
                                        label: 'בחר סוג פוליסה',
                                        value: '-1'
                                    },
                                    ...props.policyTypes
                                ]}
                                onChange={onPolicyTypeChange}
                            />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                            קבוצת לקוחות
                        </div>
                        <div className="value">
                            <input />
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item`}>
                    <div className="field">
                        <div className="title">
                        </div>
                        <div className="value">
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <div className="parameter-row">
                {/* <div className={`parameter-item checkbox-item`}>
                    <div className="field">
                        <div className="title">
                            הפקה
                        </div>
                        <div className="value">
                            
                            <select
                                value={
                                    filter.lackOfClaimsStep === null || filter.lackOfClaimsStep === undefined
                                        ? ""
                                        : filter.lackOfClaimsStep.toString()
                                }
                                onChange={(e) =>
                                    handleSelectChange("productionStep", e.target.value)
                                }
                            >
                                <option value="">ללא</option>
                                <option value="true">כן</option>
                                <option value="false">לא</option>
                            </select>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div> */}
                <div className={`parameter-item checkbox-item`}>
                    <div className="field">
                        <div className="title">
                            גביה
                        </div>
                        <div className="value">
                            {/* <input type='checkbox' checked={filter.collectionStep} onChange={(e: any) => handleCheckChange('collectionStep', e)} /> */}
                            <select
                                value={collectionStep}
                                onChange={(e) => {
                                    setCollectionStep(e.target.value);
                                    handleSelectChange("collectionStep", e.target.value)
                                }
                                }
                            >
                                <option value="">ללא</option>
                                <option value="true">כן</option>
                                <option value="false">לא</option>
                            </select>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item checkbox-item`}>
                    <div className="field">
                        <div className="title">
                            מיגון
                        </div>
                        <div className="value">
                            {/* <input type='checkbox' checked={filter.protectionStep} onChange={(e: any) => handleCheckChange('protectionStep', e)} /> */}
                            <select
                                value={protectionStep}
                                onChange={(e) => {
                                    setProtectionStep(e.target.value);
                                    handleSelectChange("protectionStep", e.target.value)
                                }}
                            >
                                <option value="">ללא</option>
                                <option value="true">כן</option>
                                <option value="false">לא</option>
                            </select>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item checkbox-item`}>
                    <div className="field">
                        <div className="title">
                            ה. תביעות
                        </div>
                        <div className="value">
                            {/* <input type='checkbox' checked={filter.lackOfClaimsStep} onChange={(e: any) => handleCheckChange('lackOfClaimsStep', e)} /> */}
                            <select
                                value={lackOfClaimsStep}
                                onChange={(e) => {
                                    setLackOfClaimsStep(e.target.value);
                                    handleSelectChange("lackOfClaimsStep", e.target.value)
                                }}
                            >
                                <option value="">ללא</option>
                                <option value="true">כן</option>
                                <option value="false">לא</option>
                            </select>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item checkbox-item`}>
                    <div className="field">
                        <div className="title">
                            מסמכים
                        </div>
                        <div className="value">
                            {/* <input type='checkbox' checked={filter.documentsStep} onChange={(e: any) => handleCheckChange('documentsStep', e)} /> */}

                            <select
                                value={documentsStep}
                                onChange={(e) => {
                                    setDocumentsStep(e.target.value);
                                    handleSelectChange("documentsStep", e.target.value)
                                }}
                            >
                                <option value="">ללא</option>
                                <option value="true">כן</option>
                                <option value="false">לא</option>
                            </select>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
                <div className={`parameter-item checkbox-item`}>
                    <div className="field">
                        <div className="title">
                            שליחה
                        </div>
                        <div className="value">
                            {/* <input type='checkbox' checked={filter.sendingToCustomerStep} onChange={(e: any) => handleCheckChange('sendingToCustomerStep', e)} /> */}
                            <select
                                value={sendingToCustomerStep}
                                onChange={(e) => {
                                    setSendingToCustomerStep(e.target.value);
                                    handleSelectChange("sendingToCustomerStep", e.target.value)
                                }}
                            >
                                <option value="">ללא</option>
                                <option value="true">כן</option>
                                <option value="false">לא</option>
                            </select>
                        </div>
                        <div className='error-message'>
                        </div>
                    </div>
                </div>
            </div>
            <button className="act-btn pointer" onClick={onApprove}>הצג דוח</button>
            <button className="act-btn pointer" onClick={onClear}>נקה בחירה</button>

        </div>
    )
}

export default AdvancedSigningSearch;